import React, { Component } from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { MuiPickersUtilsProvider,  KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import moment from 'moment-timezone';
import { DashboardLayout } from '../../../layout';
import { DocumentTitle } from '../../../../helpers';
import { userActions, defaultActions } from '../../../../common/redux/actions';
import UserProfileMenu from './partials/UserProfileMenu';
import Kids from './partials/Kids';


class UserProfileUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formField: {
                first_name: '',
                last_name: '',
                email: '',
                telephone: '',
                gender: '',
                date_of_birth: null,
                hometown: '',
                current_location: '',
                current_city: '',
                state_code: '',
                country_code: '',
                postal_code: '',
                about: '',
            },
            countryName: '',
            loading: false,
            statesLoading: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentWillMount () {
        this.updatedState();
    }

    updatedState = () => {
        const { authentication, dispatch, countries } = this.props;
        const { user } = authentication.authentication;
        countries && countries.countries.length === 0 && dispatch(defaultActions.countries());
        let userData = user.userProfile;
        //console.log('userData', userData.country_code);
        userData.country_code && userData.country_code && dispatch(defaultActions.states({code: userData.country_code}))
        let formField = { ...this.state.formField };
        formField['first_name'] = userData.first_name || '';
        formField['last_name'] = userData.last_name || '';
        formField['email'] = user.email || '';
        formField['telephone'] = userData.telephone || '';
        formField['gender'] = userData.gender || '';
        formField['date_of_birth'] = userData.date_of_birth || '';
        formField['hometown'] = userData.hometown || '';
        formField['current_location'] = userData.current_location || '';
        formField['current_city'] = userData.current_city || '';
        formField['state_code'] = userData.state_code || '';
        formField['country_code'] = userData.country_code || '';
        formField['postal_code'] = userData.postal_code || '';
        formField['about'] = userData.about || '';
        this.setState({ formField, countryName: userData.countryCode });
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    handleDateChange = (dated) => {
        let formField = {...this.state.formField};
        formField['date_of_birth'] = moment(dated).format("X");
        this.setState({formField});
    }

    handleCountries = (e) => {
        const { name, value } = e.target;
        const { dispatch } = this.props;
        let formField = {...this.state.formField};
        formField['state_code'] = '';
        if(value === null) {
            formField[name] = '';
            this.setState({formField}, () => dispatch(defaultActions.statesRemove()));
        } else {
            formField[name] = value;
            this.setState({formField}, () => dispatch(defaultActions.states({code: value})));
        }
    }

    handleStates = (event, newValue) => {
        console.log('event, newValue', event, newValue);
        let formField = {...this.state.formField};
        formField['state_code'] = newValue.code;
        this.setState({formField});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;
        if(this.validator.allValid()) {
            const { dispatch } = this.props;
            this.setState({loading: true});
            dispatch(userActions.profile("POST", { UserProfile: formField }));    
            let vm = this;
            setTimeout(function(){
                vm.setState({loading: false});
            }, 1800);        
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        this.validator.purgeFields();
        const { formField, loading, countryName } = this.state;
        const { countries, states } = this.props;
        const countriesArry = countries && countries.countries
        const statesArry = states && states.states

        return (<DashboardLayout activeClass="UserSetting">
            <DocumentTitle title={`Update Profile`}/>

            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Account Setting</h2>
                        </div>
                    </div>
                    <UserProfileMenu />
                    <div className="col-md-9">
                        <div className="post-box p-0">
                            <div className="heading">
                            Personal Info
                            </div>
                            <div className="setting-form">    
                                <form name="update_profile" method="POST" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <div className="form-group">
                                                <label>First Name<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={formField.first_name} name="first_name" onChange={this.handleChange} placeholder="Enter first name"/>
                                                {this.validator.message('first_name', formField.first_name, 'required')}
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-12">
                                            <div className="form-group">
                                                <label>Last Name<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={formField.last_name} name="last_name" onChange={this.handleChange} placeholder="Enter last name"/>
                                                {this.validator.message('last_name', formField.last_name, 'required')}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">	
                                            <div className="form-group">
                                                <label>Email<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={formField.email} name="email" disabled placeholder="Enter Email"/>
                                                {this.validator.message('email', formField.email, 'required|email')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <label>Phone Number<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={formField.telephone} name="telephone" onChange={this.handleChange} placeholder="Enter Phone Number"/>
                                                {this.validator.message('telephone', formField.telephone, 'required')}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Date of Birth</label>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                    format="MM/dd/yyyy"
                                                    margin="normal"
                                                    id="date-picker-inline"
                                                    className="input-box w-100"
                                                    placeholder="Enter Date of Birth"
                                                    value={(formField && formField.date_of_birth) ? (new Date(formField.date_of_birth * 1000)) : null}
                                                    maxDate={new Date()}
                                                    onChange={this.handleDateChange}
                                                    inputProps={{  }}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </div>
                                    </div>    

                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Address<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={formField.hometown} onChange={this.handleChange} name="hometown" placeholder="Enter Address" />
                                                {this.validator.message('hometown', formField.hometown, 'required')}
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Landmark</label>
                                                <input type="text" className="form-control" value={formField.current_location} onChange={this.handleChange} name="current_location" placeholder="Enter Landmark" />
                                                {this.validator.message('current_location', formField.current_location, 'required')}
                                            </div>
                                        </div> */}
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Country</label>
                                                <select name="country_code" className="form-control custom-select" value={formField.country_code} onChange={this.handleCountries}>
                                                    <option>Select Country</option>
                                                    {countriesArry && countriesArry.map(country => <option key={`cou-${country.id}`} value={country.code}>{country.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                       
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>State</label>
                                                <select name="state_code" className="form-control custom-select" value={formField.state_code} onChange={this.handleChange} disabled={((statesArry.length === 0) || (states.loading === true)) ? true : false}>
                                                    <option>Select Country</option>
                                                    {statesArry && statesArry.map(state => <option key={`state-${state.id}`} value={state.code}>{state.name}</option>)}
                                                </select>                                                
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>City</label>
                                                <input type="text" className="form-control" value={formField.current_city} name="current_city" onChange={this.handleChange} placeholder="Enter City"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                       
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Zip Code</label>
                                                <input type="text" className="form-control" name="postal_code" value={formField.postal_code} onChange={this.handleChange} placeholder="Enter Zip Code"/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <div className="form-group">
                                                <label>Gender</label>
                                                <RadioGroup defaultValue="female" name="gender" onChange={this.handleChange} className="d-flex flex-row"> 
                                                    <FormControlLabel value="female" control={<Radio />} label="Female" labelPlacement="end" />
                                                    <FormControlLabel value="male" control={<Radio />} label="Male" labelPlacement="end" />
                                                </RadioGroup>
                                            </div>                                          
                                        </div>
                                    </div>
                                    <div className="row">                                       
                                        <div className="col-12">
                                                <div className="form-group">
                                                <LaddaButton className="btn btn-primary btn-submit" loading={loading} data-style={EXPAND_RIGHT}>Submit</LaddaButton>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <Kids />

                            </div>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const countriesSelector = createSelector(
    state => state.countries,
    countries => countries
);

const statesSelector = createSelector(
    state => state.states,
    states => states
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    countriesSelector,
    statesSelector,
    (process, authentication, countries, states) => ({
        process, authentication, countries, states
    })
);

export default connect(mapStateToProps)(UserProfileUpdate);
